<template>
  <li
    :class="[
      'up-nav-bar-dropdown-options flex gap-2 cursor-pointer py-2.5 px-1.5 rounded hover:bg-slate-100 ',
      {
        'bg-secondary-100': isActive,
      },
    ]"
    @click="emit('click')"
  >
    <p class="text-sm text-slate-900 font-medium">
      {{ displayText }}
    </p>
    <slot name="tags" />
  </li>
</template>

<script setup lang="ts">
defineProps<{
  isActive: boolean;
  displayText: string;
}>();

const emit = defineEmits<{
  click: [];
}>();
</script>
